import React, { useCallback, useState } from "react";
import { MdCached, MdLink } from "react-icons/md";
import CarMap from "../../../CarMap";
import { formatNumber } from "~/utils/format";
import { useIntl } from "react-intl";
import { operationDesvinculaCar } from "~/api";

const LinkedCar = ({ car, reload, areas, carInformationArea }) => {
  const { formatMessage } = useIntl();
  const [isUnlinking, setIsUnlinking] = useState(false);

  const unlinkCar = useCallback(() => {
    if (!carInformationArea.B3CarsB3Proposta) return;
    setIsUnlinking(true);

    operationDesvinculaCar({
      b3_cars_b3_proposta_id: carInformationArea?.B3CarsB3Proposta.id
    }).then(() => {
      setIsUnlinking(false);
      reload();
    });
  }, [carInformationArea, reload]);

  function calcularAreaForaDePerimetro(car, areas) {
    if (!car || !areas) return { areaForaDoPerimetro: 0, porcentagemForaDoPerimetro: 0 };

    let areaForaDoPerimetro = 0;
    let areaTotalDasGlebas = 0;
    let porcentagemForaDoPerimetro = 0;

    areas.forEach((a) => {
      if (a.detalhes_json?.areas_fora_do_perimetro) {
        a.detalhes_json.areas_fora_do_perimetro.forEach((areaFora) => {
          if (car.cod_imovel === areaFora.b3_cod_imovel && areaFora.porcentagem_fora_do_perimetro < 50.01) {
            areaForaDoPerimetro += areaFora.area_fora_do_perimetro || 0;
            areaTotalDasGlebas += parseFloat(a.area_ha) || 0;
          }
        });
      }
    })
    porcentagemForaDoPerimetro = (areaForaDoPerimetro * 100) / areaTotalDasGlebas || 0;

    return { areaForaDoPerimetro, porcentagemForaDoPerimetro }
  }

  const { areaForaDoPerimetro, porcentagemForaDoPerimetro } = calcularAreaForaDePerimetro(car, areas);

  return (
    <div className="selected-car">
      <CarMap
        areaInfo={carInformationArea?.B3Car?.B3Area}
        layers={carInformationArea?.CarLayer}
        areasList={areas}
        className="area-map"
      />

      <p className="selected-car-header">
        {formatMessage({ id: "detalhes-car-detectado" })}
      </p>
      <p>
        <strong>{formatMessage({ id: "numero-car" })}:</strong> {car.cod_imovel}
      </p>
      <p>
        <strong>{formatMessage({ id: "situacao-cadastro" })}:</strong> {car.ind_status}
      </p>
      <p>
        <strong>{formatMessage({ id: "condicao-cadastro" })}:</strong> {car.des_condic}
      </p>
      <p>
        <strong>{formatMessage({ id: "area-car" })}:</strong>{" "}
        {formatNumber(car.num_area)} ha
      </p>
      <p>
        <strong>{formatMessage({ id: "tipo-imovel" })}:</strong>{" "}
        {car.ind_tipo}
      </p>
      <p>
        <strong>{formatMessage({ id: "modulos-fiscais" })}:</strong>{" "}
        {car.mod_fiscal}
      </p>
      <p>
        <strong>{formatMessage({ id: "data-registro-sicar" })}:</strong>{" "}
        {car.dataRegistro}
      </p>
      <p>
        <strong>{formatMessage({ id: "data-analise-sicar" })}:</strong>{" "}
        {car.dataAnalise}
      </p>
      <p>
        <strong>{formatMessage({ id: "data-ultima-retificacao" })}:</strong>{" "}
        {car.dataRetificacao}
      </p>
      <p>
        <strong>{formatMessage({ id: "area-intersecao" })}:</strong>{" "}
        {formatNumber(car.area_ha_intersecao)} ha
      </p>
      {areas?.detalhes_json?.areas_fora_do_perimetro !== null && (
        <p>
          <strong>{formatMessage({ id: "area-gleba-fora-do-perimetro-do-car" })}:</strong>{" "}
          {formatNumber(areaForaDoPerimetro)} ha ({formatNumber(porcentagemForaDoPerimetro)}%)
        </p>
      )}
      <div className="spacing" />

      <p className="selected-car-header">
        {formatMessage({ id: "vincular-car" })}
      </p>
      <div className="link-car-button-wrapper">
        <button
          className="unlink-car-button"
          disabled={isUnlinking}
          onClick={unlinkCar}
        >
          <MdLink size={20} /> {formatMessage({ id: "desvincular" })}{" "}
          {isUnlinking && (
            <MdCached size={20} className="loader-only-rotation" />
          )}
        </button>
      </div>
    </div>
  );
};

export default LinkedCar;
